import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { urlPath } from "../util/url.js";
import { userRoles } from "../user/constants.js";

// ======================================================================
// Static CMS pages
// ======================================================================

export var Cms = {
  path: function path() {
    return "/cms/:pageName";
  },
  location: function location(_ref) {
    var pageName = _ref.pageName;
    return {
      pathname: urlPath(_templateObject || (_templateObject = _taggedTemplateLiteral(["/cms/", ""])), pageName),
      state: undefined
    };
  },
  allowedUserRoles: [userRoles.ANONYMOUS, userRoles.B2C, userRoles.B2B]
};